import {Request} from './axios'
import Vue from 'vue'
const ApiUrl=window.g.api
const ApiList = {
  _getArticleList(context, opt) {
    return Request(ApiUrl+'getArticleList',opt)
  },
  _getArticleDetail(context, opt) {
    return Request(ApiUrl+'getArticleDetail',opt)
  },
  _getUserInfo(context, opt) {
    return Request(ApiUrl+'getUserInfo',opt)
  },
  _getArea(context, opt) {
    return Request(ApiUrl+'getArea',opt)
  },
  _subApply(context, opt) {
    return Request(ApiUrl+'subApply',opt)
  },
  _checkApply(context, opt) {
    return Request(ApiUrl+'checkApply',opt)
  },
  _getApply(context, opt) {
    return Request(ApiUrl+'getApply',opt)
  },
  _subAsk(context, opt) {
    return Request(ApiUrl+'subAsk',opt)
  },
  _getAskListM(context, opt) {
    return Request(ApiUrl+'getAskListM',opt)
  },
  _getAskList(context, opt) {
    return Request(ApiUrl+'getAskList',opt)
  },
  _getAskDetail(context, opt) {
    return Request(ApiUrl+'getAskDetail',opt)
  },
  _searchApply(context, opt) {
    return Request(ApiUrl+'searchApply',opt)
  },
  _searchAsk(context, opt) {
    return Request(ApiUrl+'searchAsk',opt)
  }
}
export default {namespaced: true, actions: ApiList}
